import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import { Subject, takeUntil } from 'rxjs'

import * as _label from '../../../label'
import * as directives from '../../directives'

@ngCore.Component({
  imports: [ngCommon.NgForOf, ngCommon.NgIf, _label.Component],
  selector: 'atn-ds-radio-options',
  standalone: true,
  styleUrls: ['./radio-options.component.scss'],
  templateUrl: './radio-options.component.html',
})
export class AtnDsRadioOptionsComponent<T = unknown> {
  @ngCore.ContentChildren(directives.value.Directive)
  public readonly radioValues:
    | ngCore.QueryList<directives.value.Directive<T>>
    | undefined

  private readonly destroy$ = new Subject<void>()

  /**
   * Label to display above radio options
   */
  public readonly labelSg = ngCore.input<string | undefined>('', {
    alias: 'label',
  })

  @ngCore.Output()
  public change = new ngCore.EventEmitter<T>()
  // TODO: Something weird is happening when trying to use this otput, it can't
  // be <T> because change.emit(radioValue.radioValue) is T | undefined, but it
  // doesn't say it's a problem when using EventEmitter<T>
  // public readonly change = ngCore.output<T | undefined>()

  ngAfterContentInit(): void {
    if (this.radioValues) {
      for (const radioValue of this.radioValues) {
        radioValue.onClick.pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.change.emit(radioValue.radioValue)
        })
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
